export class GraphItem {
  constructor(categoryIds, label, pure, invert, color) {
    this.categoryIds = categoryIds;
    this.label = label;
    this.pure = pure;
    this.invert = invert;
    this.color = color;
  }
}
